import createCachedSelector from 're-reselect';
import { createSelector } from 'reselect';
import { getEntityById } from './selectorUtils';

export const getTagsForRecommendation = createCachedSelector(
  (state, _props) => state.entities,
  (_state, props) => props.recommendation,
  (entities, recommendation) => {
    return recommendation.tags.map(tagInfo => {
      return entities[tagInfo.schema].byId[tagInfo.id];
    });
  }
)((_state, props) => props.recommendation.uuid);

export function getTag(state, tagInfo) {
  return getEntityById(state, tagInfo.schema, tagInfo.id);
}

export const getTagSearchResults = createSelector(
  state => state.entities,
  state => state.tagSearchResults.results,
  (entities, tagSearchResults) => {
    return tagSearchResults
      .map(({ id, schema }) => entities[schema].byId[id])
      .filter(tag => !!tag);
  }
);



// WEBPACK FOOTER //
// ./src/selectors/tagSelectors.js